"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '-336 -7 330 200';

var Screenshot = function Screenshot() {
  return _react["default"].createElement("path", {
    d: "m -333.95511,199.81633v-58.56111h16.93333 16.93333v41.62777 41.62778h41.80416 41.80417v16.93333 16.93334h-58.7375 -58.73749zm207.78609,41.62777v-16.93333h41.627778 41.627775v-41.62778 -41.62777h16.933333 16.9333322v58.56111 58.56111H-67.607909 -126.16902ZM-232.35512,134.90522V113.033h6.34633 6.34633l0.0919,15.61041 0.0919,15.61042 15.61041,0.0919 15.61042,0.0919v6.16994 6.16994h-22.04861 -22.04861zm77.96388,15.70228v-6.16994l15.61042,-0.0919 15.61041,-0.0919 0.0919,-15.61042 0.0919,-15.61041h6.16994 6.16995v21.87222 21.87222h-21.87223 -21.87222zM-232.35512,57.117724V35.069116 h 22.04861 22.04861v6.349998 6.35h-15.69861 -15.69861v15.69861 15.69861h-6.35 -6.35zm109.27658,6.438194 -0.0919,-15.610415 -15.61041,-0.09186 -15.61042,-0.09186v-6.346331 -6.346326h21.87222 21.87223v22.048605 22.04861h-6.16995 -6.16994zM-333.95511,-7.793384v-58.73749h58.73749 58.7375v16.93333 16.93333h-41.80417 -41.80416v41.80416 41.804167h-16.93333 -16.93333zm291.041643,16.93333v-41.80416h-41.627775 -41.627778v-16.93333 -16.93333h58.561111 58.5611072v58.73749 58.737497H-25.980134 -42.913467Z"
  });
};

var _default = (0, _createSvgIcon["default"])(Screenshot, {
  viewBox: viewBox
});

exports["default"] = _default;